export default {
  creator: '创建者',
  pleaseEnterADescription: '请输入描述',
  englishFields: '英文字段',
  name: '名称',
  sourceId: '来源ID',
  sourceAttribute: '来源属性',
  pleaseEnterRequiredField: '请输入必填项!',
  feedbackSource: '反馈来源:',
  importClassification: '导入分类',
  exportClassification: '导出所有分类',
  takeEffect: '进行生效。',
  updateToTerminal: '“更新到终端”',
  inTheManagementView: '在管理视图对分类操作后，别忘了点击',
  updateToTerminal2: '更新到终端',
  confirmUpdateTo: '确认更新到终端吗?',
  createANewFirstLevelScore: '新建一级分类',
  copyData: '复制数据',
  newSource: '新建来源',
  sourceManagement: '来源管理',
  userView: '用户视图',
  managementView: '管理视图',
  exportFailed: '导出失败:',
  exportSuccessful: '导出成功',
  deleteCategory: '删除分类',
  doYouWantToDeleteThis: '是否删除该分类?',
  optionalCustomization: '可选择自定义字段',
  feedbackFillingPage: '反馈填写页面，用户选择此分类后的额外的必填自定义字段',
  feedbackRequiredField: '反馈必填字段',
  statusIsReturned: '状态为”已回复“',
  doNotMakeAnyChanges: '不做变更',
  automaticReplyLetter: '自动回复状态变更',
  whenConfiguringSelf:
    '当配置了自动回复，用户在这个分类下提交反馈后，会收到这个分类下的自动回复文本。',
  automaticReply: '自动回复',
  pleaseSelectFeedback: '请选择反馈来源',
  pleaseInputProcessing: '请输入处理人,多个用;隔开',
  inTermsOfFeedbackTypes: '在反馈类型中可见',
  invisible: '不可见',
  so: '可见',
  visibleToUsers: '用户可见',
  pleaseEnterThePrompt: '请输入提示（不超过 250 个字）',
  customLink: '自定义链接',
  pleaseEnterCustomLink: '请输入自定义链接',
  invalidCustomLink:
    '链接格式不正确，请以 http:// 或 https:// 开头，或使用合法的协议/路径',
  classificationId: '分类ID',
  suggestionsForUsers:
    '建议在用户可见的最末级分类进行配置，配置后，用户在输入框中会看到提示内容。',
  classificationTips: '分类提示',
  tips: '提示：',
  suggestionsForUsers2:
    '建议在用户可见的最初级分类进行配置；配置后，用户在选择分类时，会在分类名下看到描述内容。',
  classificationDescription: '分类描述',
  describe: '描述：',
  classificationAttribute: '分类属性',
  pleaseEnterCorrectly: '请输入正确的处理人，多个用 ; 隔开!',
  groupLocation: '所在分组',
  number: '编号',
  thereIsCurrentlyNoAssociatedF: '暂无关联FQA信息, 点击关联FAQ',
  clickToAdd: '点击添加',
  usedAfterConfiguration:
    '配置后, 在用户选择了对应分类之后, 在反馈页面会显示对应的FAQ',
  guessWhatYouWantToAsk: '猜你想问',
  lenovoFaq: '联想 FAQ',
  confirmToDelete: '确定要删除该条关联吗?',
  searchFaq: '搜索 FAQ',
  youHaveAdded: '您已添加',
  addQuestionsTo: '添加问题至分类：',
  addFaq: '添加 FAQ',
  maximumNumberOfAssociations: '最多关联5个 FAQ，请调整后重试',
  adjustSortingTo: '调整排序成功',
  atDifferentLevels: '不同层级之间不能拖拽改变顺序',
  iteml: '{val1}子分类',
  pleaseFillInOnTheRightSide: '请在右侧填写分类详细信息',
  pleaseSelectWhatYouNeed: '请选择需要导入到的反馈来源',
  uploadCategoryE: '上传分类Excel数据',
  importFailedToSave: '导入失败, 存在以下错误:',
  theIThCategory: '第{val1}行分类存在没有父分类',
  theIThLineExists: '第{val1}行存在“未分类”, 分类名称不能包含“未分类”',
  unclassified: '未分类',
  uploadFailedE: '上传失败: {val1}',
  faile: '{val1}条数据导入失败, 存在以下错误:',
  count: '{val1}条数据导入成功',
  theUserViewIs: '用户视图为预览用户看到的目录树，不可查看详细',
  thereAreCurrentlyNoClassificationLettersAvailable:
    '暂无分类信息, 请点击分类树查看详细信息',
  classificationManagement: '分类管理',
  helpAndFeedback: '用户分类',
  deleteSourceMissing: '删除来源失败!',
  deleteSource: '删除来源成功!',
  deleteCategoryLost: '删除分类失败!',
  deleteClassificationAs: '删除分类成功!',
  updateToTerminal3: '更新到终端失败!',
  updateToTerminal4: '更新到终端成功!',
  firstLevelClassificationName: '一级分类名',
  relatedFaQs: '关联faq失败!',
  relatedFaQs2: '关联faq成功!',
  newSourceLost: '新建来源失败!',
  busin: '{val1}来源成功!',
  level: '{val1}分类失败!',
  level2: '{val1}分类成功',
  pleaseEnterANote: '请输入备注',
  remarks: '备注',
  enableRules: '启用规则',
  relationshipBetweenConditions: '条件间关系',
  addTo: '添加',
  lengthRestrictionGrid: '长度限制格式为JSON: {"max":xxx, "min": xxx}',
  pleaseSelectFilter: '请选择筛选条件',
  inMultipleProjects: '在多项目中命名相同的来源里生效',
  applicableAfterOpening:
    '开启后, 适用于所属二级产品下所有项目, 对应项目下同步呈现该规则',
  multiProjectApplication: '多项目应用',
  pleaseEnterInvalid: '请输入无效规则名称',
  pleaseEnterTheRules: '请输入规则名称',
  ruleName: '规则名称',
  invalidRuleCreation: '无效规则创建成功',
  invalidRulesAreMore: '无效规则更新成功',
  newInvalidRule: '新建无效规则',
  newlyBuild: '新建',
  invalidRule: '无效规则',
  or: '或',
  and: '且',
  totalTota: '共 {val1} 条',
  areYouSureYouWantToDelete: '您确定要删除该无效规则吗？(删除后不能恢复)',
  operator: '操作人',
  updateTime: '更新时间',
  enable: '启用',
  yes: '是',
  invalidRuleName: '无效规则名称',
  deleteInvalidRules: '删除无效规则成功',
  statu: '{val1}无效规则成功',
  onTheUserPage: '在用户页面中输入值时的提示文字',
  inputPromptText: '输入提示文字',
  fieldAnnotation: '字段注释',
  adminDisplayCopy:
    '用于说明单选、复选各选项的含义，作为反馈详情页自定义字段的提示文案',
  doWeNeedASchool: '是否需要校验',
  canBeReversedOnThePlatform: '可在平台反馈列表中修改',
  canItBeModified: '是否可修改',
  inUserSubmission: '在用户提交反馈页面中是否展示该字段',
  canTheUser: '用户是否可见',
  isItMandatory: '是否必填',
  isSensitive: '是否为敏感词',
  sensitiveInfo: '在管理端和下载数据时，用星号代替该字段值。',
  pleaseEnterSorting: '请输入排序',
  sortNumericalValues: '排序数值',
  sort: '排序',
  theFieldValueIsNot: '字段数值不能为空',
  addOptions: '添加选项',
  pleaseEnterOptionLabel: '请输入选项展示名',
  pleaseEnterOptionValue: '请输入唯一标识（字母/数字）',
  fieldValueOptions: '字段值选项',
  maximumNumberOfCharacters: '最大字符数限制',
  minimumNumberOfCharacters: '最小字符数限制',
  cSideSection: 'C端',
  adminSideSection: '管理端',
  inputPromptPlaceholder: '在用户填写时的输入框提示文案',
  visible: '是否可见',
  sortFieldTooltip: '控制反馈填写表单和管理端的字段展示顺序',
  commonFieldTooltip: '反馈填写时的通用字段',
  pleaseSelectAField: '请选择字段类型',
  fieldType: '字段类型',
  lettersOrNumbers: '字母或数字格式, 用于接口传递参数',
  fieldId: '字段ID',
  whenReportingFeedback: '上报反馈时填写的字段名字',
  userEndOrFlat: '用户端或平台页面中展示的信息（唯一性)',
  fieldName: '字段名称',
  feedbackPage: '反馈信息页面中，按此列表中的排序展示字段内容',
  title: '{val1}字段',
  pleaseCompleteTheForm: '请完善表单填写',
  customFields: '自定义字段修改成功',
  customFields2: '自定义字段添加成功',
  pleaseAddFields: '请添加字段值选项',
  currentNam: '当前{val1}已存在，请重新填写',
  pleaseEnterNa: '请输入{val1}',
  defaultRemarks: '默认备注',
  defaultName: '默认名称',
  newlyAdded: '新增',
  link: '链接',
  jsonWord: 'JSON字符串',
  name2: '人名',
  check: '复选',
  singleChoice: '单选',
  floatingPointNumbers: '浮点型数字',
  integerNumber: '整型数字',
  text: '文本',
  doYouWantToDelete: '是否要删除字段',
  deleteCustom: '删除自定义字段',
  pleaseEnterTheField: '请输入字段名称',
  newFieldsAdded: '新增字段',
  customFields3: '自定义字段删除失败',
  customFields4: '自定义字段删除成功',
  sensViewPermTitle: '申请查看权限',
  sensViewPermDesc2: '提交后请告知管理员（{val1}）审批。',
  sensViewPermSucc: '申请已提交',
  sensViewPermFail: '申请提交失败',
  grantPermTitle: '开启敏感字段明文查看',
  grantPermDesc1: '确定为敏感自定义字段「{val1}」（{val2}）开启明文查看？',
  grantPermDesc2:
    '开启后，可在支持的场景下查看该字段明文；可随时关闭并恢复脱敏。',
  grantPermSucc: '已开启明文查看',
  grantPermFail: '开启失败',
  closePlainViewTitle: '关闭敏感字段明文查看',
  closePlainViewDesc1: '确定为敏感自定义字段「{val1}」（{val2}）关闭明文查看？',
  closePlainViewDesc2: '关闭后相关位置将脱敏展示，需要时可再次开启。',
  closePlainViewSucc: '已关闭明文查看',
  closePlainViewFail: '关闭失败',
  isItMandatory2: '是否必选',
  fieldRemarks: '字段备注',
  maximumNumberOfCharacters2: '最大字符数',
  minimumNumberOfCharacters2: '最小字符数',
  pendingOnline: '待上线',
  totalTota2: '共 {val1} 项',
  confirmToDelete2: '确定删除',
  confirmCancellation: '确定取消?',
  confirmRelease: '确定发布?',
  announcementLink: '公告链接',
  announcementContent: '公告内容',
  pleaseSelectAnnouncement: '请选择公告生效时间!',
  entryIntoForceTime: '生效时间',
  pleaseEnterTheAnnouncement: '请输入公告链接!',
  pleaseEnterTheAnnouncement2: '请输入公告内容!',
  editAnnouncement: '编辑公告',
  newAnnouncement: '新建公告',
  announcementServiceReleased: '公告服务出现异常: {val1}',
  announcementDataHasBeenReleased: '公告数据已经太长了请先删除无用的公告数据',
  noNeedForRepair: '没有需求修改的公告!',
  noNeedToDelete: '没有需要删除的公告!',
  announcementHasExceeded: '公告已经超过 {val1} 条不允许再新建公告!',
  announcementServiceDifferences: '公告服务异常: {val1}',
  announcementList: '公告列表',
  announcementServiceDifferences2: '公告服务异常!',
  graphicTutorialAttack: '图文/教程/攻略',
  announcementBoard: '公告栏',
  announcementGraphicAndText: '公告图文',
  createANewImageAndText: '新建图文',
  imageAndTextServicesAreAvailable: '图文服务出现异常: {val1}',
  theGraphicAndTextualDataHasBeenProcessed:
    '图文数据已经太长了请先删除无用的图文数据',
  noNeedForRepair2: '没有需求修改的图文!',
  noNeedToDelete2: '没有需要删除的图文!',
  theGraphicsAndTextHaveExceededTheLimit:
    '图文已经超过 {val1} 个不允许再新建图文!',
  differentGraphicAndTextualServices: '图文服务异常: {val1}',
  differentGraphicAndTextualServices2: '图文服务异常!',
  graphicAndTextualLinks: '图文链接',
  imageAndTextTitle: '图文标题',
  graphicCover: '图文封面',
  pleaseUploadPicturesAndText: '请上传图文封面!',
  pleaseSelectTextAndImage: '请选择图文排序位置!',
  textAndImageSorting: '图文排序',
  pleaseInputTextAndImages: '请输入图文链接!',
  pleaseInputTextAndImages2: '请输入图文标题!',
  uploadCover: '上传封面',
  cannotExceedM: '不能超过 {val1}M.',
  doesNotSupportFi: '不支持 {val1} 类型上传',
  unableToObtainIt: '获取不到上传的图片.',
  editImagesAndText: '编辑图文',
  hotspotSorting: '热点排序',
  groupSorting: '分组排序',
  cEndUsersAreVisible: 'C端用户是否可见',
  grouping: '分组',
  answer: '回答',
  extensionInfo: '扩展信息',
  faqProcessingInfo: '处理信息',
  faqExtensionTags: '扩展标签',
  faqExtensionTagsCountError: '扩展标签最多可设置 20 个',
  faqExtensionTagsItemError: '单个扩展标签最多 64 个字符，且不能包含英文分号',
  faqExtensionTagsBytesError: '扩展标签总长度不能超过 1024 字节',
  faqProcessingStatus: '当前处理状态',
  faqStatusUnset: '未设置',
  faqStatusReplied: '已回复',
  faqStatusProcessing: '处理中',
  faqStatusProcessed: '已处理',
  faqReplyContent: '回复内容',
  newQuestion: '新建问题',
  editQuestionS: '编辑问题',
  theProblemCannotBe: '问题不得为空或超过200个字符!',
  defaultGrouping: '默认分组',
  nextPicture: '下一张',
  ifYouOnlyWantToStop: '如仅想停止对用户的展示，可以使用“停用”。',
  afterDeletionThereWillBeNo: '删除后将无法恢复，请谨慎操作。',
  deleteFaq: '删除 FAQ',
  strin: '{val1}热点',
  showMore: '显示更多',
  hotspot: '热点',
  stopUsing: '停用',
  copyFailed: '复制失败',
  copySuccessful: '复制成功',
  addQuestions: '添加问题',
  quicklyAddYours: '快添加你的第一个问题吧！',
  noProblemAtTheMoment: '暂无问题',
  page: '页',
  the: '第',
  articleRecord: '条记录',
  common: '共',
  answer2: '答案',
  totalTota3: '共{val1}个问题',
  cancelSelection: '取消选择',
  term: '项',
  downloadTemplate: '下载模板',
  batchImport: '批量导入',
  batchExport: '批量导出',
  uploadFailed: '上传失败',
  theIThItemInTheDocument: '文件中第{val1}行数据有误，提示: {val2}',
  statu2: '{val1}失败!',
  statu3: '{val1}成功!',
  thisFaqHasBeenSent: '该faq已关联 "{val1}" 分组 - 请解除关联后重试!',
  isHot: '{val1}热点失败!',
  isHot2: '{val1}热点成功!',
  tipsF: '{val1} Faq 问题成功.',
  tipsF2: '{val1} Faq 问题失败 - 内容重复.',
  tipsF3: '{val1} Faq 问题失败 - 接口请求发生错误.',
  groupIcon: '分组图标',
  groupName: '分组名',
  newGroup: '新建分组',
  editGroup: '编辑分组',
  defaultGrouping2:
    '默认分组内的FAQ不会出现在用户端，除非被设为热点或者转到其他分组。',
  deleteGroup: '删除分组',
  youCanAddressTheIssue: '可以在问题内容管理中将问题设为热点问题哦！',
  noGroupingAvailableAtTheMoment: '暂无分组',
  deleteSuccessfully: '删除成功',
  group: '{val1}分组信息成功!',
  group2: '{val1}分组信息失败!',
  aHotTopicIssue: '个热点问题',
  share: '共有',
  cancelHotspotLoss: '取消热点失败!',
  cancelHotspot: '取消热点成功!',
  adjustHotspotF: '调整热点FAQ顺序失败!',
  adjustHotspotF2: '调整热点FAQ顺序成功!',
  cancelHotspot2: '取消热点',
  returnToGroup: '返回分组',
  aQuestion: '个问题',
  importProblem: '导入问题',
  title2: '{val1}FAQ成功',
  title3: '{val1}FAQ失败,内容重复',
  title4: '{val1}FAQ失败,接口请求发生错误',
  removeTheProblem: '移出问题成功',
  removeFromGroup: '移出分组',
  moreOperationNotes: '更多操作记录',
  operationHistory: '操作历史',
  hotContentManagement: '热点内容管理',
  groupManagement: '分组管理',
  problemContentManagement: '问题内容管理',
  faqManagement: 'FAQ管理',
  enabled: '已启用',
  modelInf: '模型: {val1}',
  newModel: '新建模型',
  copyModel: '复制模型',
  viewModel: '查看模型',
  changeTime: '修改时间',
  modelDescription: '模型说明',
  current: '当前',
  modelName: '模型名称',
  totalTota4: '共 {val1} 条',
  modelReplicationLost: '模型复制失败:{val1}',
  copyTheModelInto: '模型复制成功',
  modelCopyingInProgress: '模型复制中，请稍等',
  doYouWantToCopyIt: '是否复制所选模型？',
  exportModelLost: '导出模型失败:{val1}',
  modelDownloadLocation: '模型下载地址为空',
  exportNotAllowed: '当前模型不支持导出',
  modelDeletionLost: '模型删除失败:{val1}',
  modelDeletedAs: '模型删除成功',
  doYouWantToDeleteIt: '是否删除所选模型？',
  startTheModel: '启动该模型失败:{val1}',
  enableThisModel: '启用该模型失败',
  successfullyEnabledThis: '成功启用该模型',
  areYouSureToStart: '是否确定启用当前所选模型？',
  modificationFailedPlease: '修改失败: 请确认修改信息后重试!',
  theParentNodeCannot: '父节点无法移动至子节点,当前分类已重置',
  sameNameExists: '存在相同名字的分类,当前分类已重置',
  addIte: '新增{val1}子分类',
  addAFirstLevelScore: '新增一级分类',
  addSel: '新增{val1}子分类',
  pleaseReferToTheTableBelow: '请在下方表单中填写相关信息并保存完成分类添加',
  pleaseUploadTheFile: '请上传文件并生成模型',
  displayDisabled: '显示禁用',
  draggingSucceeded: '拖拽成功更新优先级',
  hideDisabledPoints: '隐藏禁用分类',
  displayDisabledPoints: '展示禁用分类',
  aisee: 'Aisee小助手',
  needToActivateSelf: '需要开通自动回复, 请联系',
  whenConfiguringSelf2:
    '当配置了自动回复内容,智能分类匹配到此分类后,会收到这个分类下的自动回复文本。',
  automaticReplyConfiguration: '自动回复配置',
  existsUnderTheCategory: '分类下存在子分类，请确认是否继续删除？',
  areYouSureToDelete: '是否确认删除？',
  historicalData: '历史数据：',
  priority: '优先级：',
  senior: '高级',
  batchAdd: '批量新增',
  addBlockingWords: '新增屏蔽词',
  thereAreCurrentlyNoBlockedWordsAvailable: '暂无屏蔽词',
  blockWords: '屏蔽词：',
  ifSelectedAfterConfiguration:
    '配置后，若选中的自定义字段有值, 则命中该智能分类',
  customFields5: '自定义字段：',
  addErrorCode: '新增错误码',
  errorCode: '错误码',
  thereAreCurrentlyNoErrorCodesAvailable: '暂无错误码',
  errorCode2: '错误码：',
  learnNewWords: '学习新词',
  addNewWordFrequency: '新增词频',
  wordFrequency: '词频',
  noWordFrequencyAvailableAtTheMoment: '暂无词频',
  wordFrequency2: '词频：',
  addImageClose: '新增图片关键词',
  noPicturesAvailableAtTheMoment: '暂无图片关键词',
  imageKeywords: '图片关键词：',
  addNewKeywords: '新增关键词',
  noKeywordsAvailableAtTheMoment: '暂无关键词',
  keyWord: '关键词：',
  businessScenarios: '业务场景',
  afterConfigurationTheCommandWillBeActivated:
    '配置后，当命中该分类时，将反馈类型修改成所选的值',
  feedbackType: '反馈类型：',
  pleaseFillInTheTitle: '请填写标题',
  title5: '标题：',
  basicConfiguration: '基础配置',
  batchAddM: '批量新增{val1}',
  successfullyUpdatedWord: '成功更新词频',
  updateWordFrequency: '更新词频中',
  categoryDeletedAs: '分类删除成功',
  categoryAddedAs: '分类添加成功',
  updateFailedPlease: '更新失败: 请检查标题是否重复!',
  updateSuccessful: '更新成功',
  imageKeywords2: '图片关键词',
  blockWords2: '屏蔽词',
  reasoningProcess: '推理过程：',
  predictiveClassification: '预测分类：',
  pleaseEnterText: '请输入文本',
  enterText: '输入文本：',
  saveModel: '保存模型',
  uploadGeneratedModel: '上传生成模型',
  unsupervisedDownload: '下载无监督模板',
  downloadWithSupervision: '下载模板',
  pleaseEnterTheModel: '请输入模型说明',
  thereIsCurrentlyNoModelAvailable: '暂无模型说明',
  modelDescription2: '模型说明：',
  pleaseEnterTheModel2: '请输入模型名称',
  modelName2: '模型名称：',
  model: '模型',
  intelligentClassification: '智能分类-',
  uploadFormatIsIncorrect: '上传格式不正确，请上传xls或者xlsx格式',
  noPredictionsAvailableAtTheMoment: '暂无预测数据',
  successfulPrediction: '成功预测',
  modelUpdatedTo: '模型更新成功',
  modelCreation: '模型创建成功',
  pleaseFillInTheModel: '请填写模型名称',
  usedForIntelligentClassification: '智能分类（用/分隔，如增长/提现）',
  pleaseEnterCo: '请输入{val1}，多个使用逗号或空格分割',
  noResultsAvailablePlease: '暂无结果，请先输入反馈ID进行检测',
  detectionResult: '检测结果',
  reset: '重置',
  pleaseEnterTheReverseFirst: '请先输入反馈ID',
  feedbackId: '反馈ID',
  sessionId: '会话ID',
  testing: '检测',
  checkFailed: '检查失败',
  pleaseProvideFeedback: '请输入反馈ID',
  pleaseFillTriggerCondition: '请填写触发条件',
  addPlugin: '新增插件',
  noteListOnTheLeft: '备注：列表左侧拖拽按钮可以调整触发顺序',
  historicalTriggerRecord: '历史触发记录',
  manuallyTriggeredPress: '人工触发按照启用顺序在反馈详情页排序',
  manuallyTriggered: '人工触发',
  customFieldTrigger: '自定义字段触发',
  automaticTriggerPress: '自动触发按照启用顺序执行',
  automaticTriggering: '自动触发',
  processingPlugins: '处理插件',
  pluginManagement: '插件管理',
  pluginListTab: '插件列表',
  pluginCenter: '插件中心',
  pluginManager: '插件管理',
  pleaseEnterAResponse: '请输入响应结构路径',
  responseStructurePath: '响应结构路径',
  requestHeader: '请求头',
  parameter: '参数',
  interfaceTimeoutInSeconds: '接口超时(秒)',
  pleaseEnterAp: '请输入API',
  pleaseSelectTrigger: '请选择触发方式',
  triggerMethod: '触发方式',
  pluginUsage: '插件用途',
  pleaseEnterThePlugin: '请输入插件名称',
  pluginName: '插件名',
  editPlugin: '编辑插件',
  pleaseEnterVa: '请输入value{val1}',
  pleaseEnterKe: '请输入key{val1}',
  updatePluginMissing: '更新插件失败: ',
  updatePluginsTo: '更新插件成功',
  newPluginLost: '新建插件失败:',
  createANewPlugin: '新建插件成功',
  pleaseEnterCorrectly2: '请输入正确的API链接',
  pleaseEnterThePlugin2: '请输入插件名',
  field: '字段',
  fieldName2: '字段名',
  triggerOrderDrag: '触发顺序拖拽失败',
  triggerOrderDrag2: '触发顺序拖拽成功',
  startupSuccessful: '启动成功',
  isItEnabled: '是否启用',
  purpose: '用途',
  triggerType: '触发类型：',
  fail: '失败',
  success: '成功',
  executionStatus: '执行状态：',
  pluginName2: '插件名称：',
  feedbackId2: '反馈ID：',
  coCoun: '共 {val1} 条',
  triggerPerson: '触发人',
  triggerTime: '触发时间',
  returnResult: '返回结果',
  passInParameters: '传入参数',
  executionStatus2: '执行状态',
  pluginName3: '插件名称',
  pleaseEnterTheLabel: '请输入标签名或关键词',
  automaticallyLabel: '自动打标签',
  pleaseUseATemplate: '请使用模板进行导入',
  newLabel: '新建标签',
  businessTags: '业务标签',
  focusOnFailure: '关注失败',
  followSuccess: '关注成功',
  modificationFailed: '修改失败',
  theIThItemInTheDocument2: '文件中第{val1}行数据有误，提示: {val2}',
  tagListAcquisition: '标签列表获取失败：{val1}',
  follow: '关注',
  cancelFollow: '取消关注',
  systemLabel: '系统标签',
  priority2: '优先级',
  tagName: '标签名称',
  totalTota5: '共{val1}条',
  pleasePrioritize: '请确定优先级(数值大于等于0)',
  pleaseEnterCorrectly3: '请输入正确的数字形式',
  multipleKeywords: '多个关键词以空格分隔',
  fuzzyMatch: '模糊匹配',
  pleaseEnterTheLabel2: '请输入标签名',
  pleaseEnterCorrectly4: '请正确输入标签名',
  tagName2: '标签名',
  deleteThisTag: '该标签删除后，相应反馈将不能通过该标签检索；删除后不可恢复。',
  confirmToDeleteTheLabel: '确定删除标签:',
  intTa: '{val1}标签`)}',
  deleteFailed: '删除失败',
  newCreationFailed: '新建失败',
  newCreatedSuccessfully: '新建成功',
  ifYouWishTo:
    '如您希望在用户提交反馈的页面中，发布一些重要的公告，可以在AiSee中直接设置引用，这将帮您省去一部分开发成本。',
  ifNeededForSome:
    '若需对一些反馈数据打上特定标签，AiSee支持标签的设置与应用。',
  basedOnTheAlreadyGenerated:
    '基于已产生的用户反馈，当您需要联动业务系统中获取更全面的信息时，可通过插件实现。',
  ifNecessary:
    '如果需要将某些无效的反馈数据过滤掉，您可以根据自己的需要设置一些规则，包含且不限于特定的字段值、正则表达式等。',
  theUserIsSubmitting:
    '用户在提交反馈时，如果希望他们选择问题类别，AiSee可以帮助您预设相应的分类。',
  inUserFeedback:
    '在用户反馈上报的系统信息之外，若您还需要获知更多的内容或特定业务信息，请在自定义信息中设置您的专属字段。',
  youCanTarget:
    '您可以针对某些常见的问题设置FAQ，用于在对应分类下自动回复用户，或支持运营团队选择合适的内容手动回复用户。',
  youCanBaseItOn:
    '您可以根据业务设置自己的分类集，当用户反馈产生时，平台帮助您实现自动分类。',
  replyStatus: '人工回复状态',
  clickToExpandEmptySpace: '点击展开空值字段',
  clickToCollapse: '点击收起',
  operationHistoryRecord: '操作历史记录',
  systemFields: '系统字段',
  openAiDay: '开通AI日志分析',
  clickToViewTheMost: '点击查看最佳实践',
  byAnalyzingAndUsing:
    '遇到问题不用急，Ai来帮你！轻点「一键分析」，秒级定位异常根因。',
  logAnalysis: '日志分析',
  unbindTap: '解绑Tapd',
  copyLinkSplit: '复制链接分享',
  screenshot: '屏幕截图(',
  feedbackInThePastYear: '近一年反馈',
  to: '于',
  feedbackContentT: '反馈内容: {val1}\n{val2}',
  releaseTap: '解除TAPD绑定成功!',
  opera: '{val1}失败',
  opera2: '{val1}成功',
  logInformation: '日志信息',
  issue: 'issueId为空',
  noChangeHistoryAvailableAtTheMoment: '暂无变更历史',
  remarks2: '备注:',
  informationEditing: '信息编辑',
  processingRecords: '处理记录',
  city: '城市',
  country: '国家',
  countryChina: '中国',
  countryThailand: '泰国',
  countryIndonesia: '印尼',
  countryIndonesiaFull: '印度尼西亚',
  countryMalaysia: '马来西亚',
  countryVietnam: '越南',
  countrySingapore: '新加坡',
  countryIndia: '印度',
  countrySouthKorea: '韩国',
  countryPhilippines: '菲律宾',
  countryJapan: '日本',
  countryBrazil: '巴西',
  countryMexico: '墨西哥',
  countryUnitedStates: '美国',
  network: '网络',
  userIp: '用户IP',
  isItRoo: '是否Root',
  systemVersion: '系统版本',
  model2: '型号',
  manufacturer: '厂商',
  equipmentAndRegion: '设备与地域',
  userTags: '用户标签',
  clickToGoToEach: '点击后向每个处理人发送1条企业微信提醒消息',
  clickToSend: '点击发送通知',
  businessInformation: '业务信息',
  sourceLink: '来源链接',
  receivingTime: '接收时间',
  chooseManualTouch: '选择人工触发的插件手动执行，字段更新结果在变更历史中记录',
  executePlugin: '执行插件',
  essentialInformation: '基本信息',
  notifyRec: '通知: {val1} 出现错误请重试',
  notifyRe: '已通知: {val1}',
  pleaseAddProcessing: '请添加处理人再发送通知',
  enterCategoryName: '输入分类名称搜索',
  searchFeedbackWithin: '搜索反馈内容',
  itemt: '{val1}(无分类)',
  content: '内容',
  whenThePlatformReceives: '接收时间',
  pleaseChooseFi: '请选择{val1}',
  pleaseEnterFi: '请输入{val1}',
  tapdFinished: 'TAPD完结',
  transferToTapd: '转TAPD',
  oncal: 'Oncall结单',
  feedbackProcessingRecord: '反馈处理记录(',
  contactInformation: '联系方式',
  feedbackClassification: '反馈分类:',
  noPermissionToRepairTemporarily: '暂无权限修改分类',
  transferredToPar: '已转{val1}',
  feedbackProcessingStatus: '反馈处理状态',
  feedbackProcessingStatusTips: '会话转问题、tapd、oncall的处理状态',
  whenSubmittingFeedback: '反馈时间',
  clickToViewForUse: '点击查看用户【{val1}】近1年反馈历史',
  modifyIntelligentScore: '修改智能分类成功!',
  opera3: '{val1}失败',
  opera4: '{val1}成功',
  exportAllNumbers: '导出全部数据',
  feedbackInput: '反馈录入，仅管理员可见',
  moreOperations: '更多操作',
  batchEditing: '批量编辑',
  batchReply: '批量回复',
  batchAiPush: '批量AI推荐回复',
  batchExc: '批量Excel导入',
  singleFeedbackRecord: '单条反馈录入',
  batchCancelClose: '批量取消关注',
  batchFollow: '批量关注',
  batchDownload: '批量下载',
  opera5: '{val1}失败',
  opera6: '{val1}成功',
  clickOnDescendingOrder: '点击降序',
  cancelSorting: '取消排序',
  clickOnAscendingOrder: '点击升序',
  pleaseSelectAttributes: '请选择属性标签',
  attributeTags: '属性标签',
  ifThereIsNoneAfterInput: '输入后若无对应标签,按enter键可新增',
  pleaseSelectFeedback2: '请选择反馈类型',
  pleaseSelectAUser: '请选择用户分类',
  informationHasBeenEntered:
    '已输入信息覆盖对应当前的反馈内容，未输入的信息保留原值。',
  additionFailed: '新增失败',
  newSuccessfullyAdded: '新增成功',
  customFields6: '自定义字段编辑',
  systemFieldCoding: '系统字段编辑',
  pleaseSelectBusiness: '请选择业务场景',
  afterSubmittingFeedback: '反馈提交后，向所有处理人自动推送 1 条企微通知',
  searchForMembers: '搜索成员昵称并选择',
  upToFiveUploadsAllowed: '最多上传五张图片，图片最大 10M',
  feedbackAttachment: '反馈附件',
  userFeedback: '用户反馈的原始链接，新增后可在反馈列表中点击跳转',
  pleaseEnterTheLink: '请输入链接',
  whenReceivingUserFeedback: '用户反馈时间',
  pleaseSelectFeedback3: '请选择反馈类型!',
  pleaseProvideFeedback2: '请输入反馈来源!',
  pleaseEnterTheUser: '请输入用户ID或账号',
  theInputContentIsNot: '输入内容不能超过200个字符',
  pleaseEnterTheUser2: '请输入用户信息(用户ID或账号)!',
  pleaseEnterTheUser3: '请输入用户反馈内容',
  pleaseEnterTheUser4: '请输入用户反馈内容!',
  reasonForFailure: '失败原因：',
  singleMaximumLead: '单次最多导入 2,000 条数据',
  clickToUploadE: '点击上传 Excel 文件',
  clickToDelete: '点击删除',
  pleaseProvideFeedback3: '请输入反馈数据!',
  downloadImportModel: '下载导入模版',
  https:
    'https://mf-dcl-1258344701.cos.ap-guangzhou.myqcloud.com/aisee%E7%AE%A1%E7%90%86%E7%AB%AF%E6%A8%A1%E7%89%88%E6%96%87%E4%BB%B6/AiSee%E5%8F%8D%E9%A6%88%E4%BF%A1%E6%81%AF%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-v4.xlsx',
  uploadFeedbackCount: '上传反馈数据',
  userFeedbackRecord: '用户反馈录入',
  usedForBatchImport: '批量导入用户反馈',
  singleMaximumLead2: '单次最多导入2000条数据',
  singleMaximumLead3: '单次最多导入{val1}条数据',
  feedbackOnLineI: '第{val1}行，反馈类型为空',
  feedbackOnLineI2: '第{val1}行, 反馈用户为空',
  feedbackOnLineI3: '第{val1}行, 反馈内容为空',
  tableDataError: '表格数据错误，请上传正确的数据',
  inputFailedE: '录入失败：{val1}',
  inputSuccessful: '录入成功',
  importFailedE: '导入失败：{val1}',
  importSuccessful: '导入成功',
  importResult: '导入完成：成功{val1}条，失败{val2}条',
  importFailed: '导入失败，请重试',
  importFailedRetryResult: '导入失败，请重试：已成功导入{val1}条，失败{val2}条',
  pleaseUploadTheDocumentFirst: '请先上传文件',
  timeSpanIsNot: '时间跨度不能超过一年请重新选择!',
  intelligentProcessing: '智能处理',
  userInformation: '用户信息',
  pleaseSelectATime: '请选择时间',
  pleaseSelectATimeOrFid: '请选择时间范围或者反馈id',
  search: '搜索',
  itemt2: '{val1}(无分类)',
  optionalRangeOnly: '可选范围仅限当前所在二级产品下的应用',
  belongingToLevel3: '所属三级应用',
  pleaseChooseFi2: '请选择{val1}',
  pleaseEnterFi2: '请输入{val1}',
  transferredToPar2: '已转{val1}',
  currentProduct: '当前产品',
  batchModificationReverse: '批量修改反馈类型',
  batchModifyFeedbackClass: '批量修改反馈分类',
  batchClassDifferentModel: '所选反馈属于不同分类模型，请分开修改',
  batchClassTreeMissing: '分类树加载失败，请关闭后重试',
  batchClassTreeLoading: '正在分析所选反馈是否可批量修改反馈分类',
  batchClassTreeUpdate: '所选反馈模型一致，可直接更新',
  batchClassMissingApp: '缺少反馈所属应用，无法完成操作',
  allApplications: '全部应用',
  personalCenter: '个人中心',
  intMine: '{val1}',
  intMine2: '{val1}',
  pleaseProvideFeedback4: '请输入反馈内容',
  viewMore: '查看更多',
  theLatestFourQuestions: '最新4条问题',
  waitingForMyApprovalAuthority: '待我审批权限',
  recentlyFollowed: '近1年关注的反馈',
  inRecentYearsItIsExpectedToHappenAgain: '近1年待再次回复',
  recentlyReplied: '近7天已回复',
  followUpInRecentDays: '近30天跟进中问题',
  processedInRecentDays: '近7天已处理问题',
  inputSessionMinutes: '输入会话分类搜索',
  pleaseSelectAConversation: '请选择会话分类',
  searchForSessionMaster: '搜索会话主题',
  topicOfTheConversation: '会话主题',
  sessionClassification: '会话分类:',
  conversationProcessingStatus: '会话处理状态',
  associated: '已关联',
  // 是否转人工，目前使用关联反馈 等前端工单上线的改为反馈“关联工单”
  whetherToTransferManually: '是否转人工',
  relatedFeedback: '关联反馈',
  sourceOfConversation: '会话来源',
  recor: '{val1}分',
  openWidescreenMode: '开启宽屏模式',
  turnOffWidescreenMode: '关闭宽屏模式',
  numberOfConversationParticipants: '会话人数',
  numberOfUnSolvedAIFeedback: 'AI未解决数量',
  numberOfSessions: '会话数量',
  getFeedbackColumn: '获取反馈列表失败:',
  enableOldModelTag: '是否开启旧模型标签',
  oldModelTagSetSuccess: '设置成功',
  oldModelTagSetFailed: '设置失败',
  masterControl: '主控',
  onlineConsultation: '在线咨询',
  sessionDetails: '会话详情',
  helloThankYou: '您好，感谢您的耐心等待，请您详细描述一下您遇到的问题',
  customerService: '客服01',
  iHaveContactedYou: '已为您联系人工客服，请您耐心等待，客服人员将尽快为您解答',
  manualService: '人工服务',
  sorryForTheCurrentLocation:
    '抱歉，当前处于非工作时间(工作时间为工作日的9:00-19:00期间)，人工客服上线后将第一时间回复您',
  pleaseEnterEnterpriseWeChat:
    '请输入企微英文帐号，多个以 , 或 ; 分隔，如：zhangsan;lisi;',
  dialogueStrategy: '对话策略',
  enterpriseMicroConfiguration: '企微配置',
  whenACEndUser:
    '当c端用户请求人工服务时，处于客服非工作时间，自动发送给用户的提示信息',
  whenManuallyOffline: '人工离线时间提示语',
  whenACEndUser2:
    '当c端用户请求人工服务时，处于客服工作时间内，自动发送给用户的提示信息',
  whenManuallyOnline: '人工在线时间提示语',
  weekendsAndStatutes: '周末及法定节假日',
  humanCustomerServiceIsAvailable: '人工客服在线时间（非工作日）',
  defaultToWork: '默认为工作日，不含周末及法定节假日',
  humanCustomerServiceIsAvailable2: '人工客服在线时间（工作日）',
  humanCustomerServiceIsAvailable3: '人工客服在线提示',
  whenManuallyResponding: '当人工回复消息时，在c端用户界面中显示的名称',
  artificialCustomerService: '人工客服昵称设置',
  humanCustomerServiceHead: '人工客服头像',
  largeModelRecognition: '大模型识别特定场景（情绪激动等）时，自动转人工',
  automaticRecognitionAfterRecognition: '识别后自动转人工',
  answeringMoreThanRound: '回答超过3轮，弹出转人工按钮，用户点击后转人工',
  sendToManual: '发送转人工按钮给用户',
  intelligentCustomerServiceTransfer:
    '智能客服转人工的不同方式，不同方式覆盖的回答场景不同',
  autoTransferToManualSceneSetting: '自动转人工场景设置',
  intelligentCustomerServiceTransfer2: '智能客服转人工的方式',
  artificialCustomerServiceBase: '人工客服设置',
  pleaseEnterAi: '请输入用户情绪过激的提示语',
  whenAiFails: '当AI未能识别用户意图时，自动发送给用户的提示信息',
  aiIntentIsNot: 'AI 意图未识别提示语',
  correspondingCopy: '对应话术',
  userEmotionalExcited: '用户情绪过激',
  specificScene: '匹配到特定场景',
  specificSceneSetting: '转人工特定场景设置',
  collectInfoCardScene: '匹配到收集信息卡片场景',
  nextTimePush: '次时推送',
  duringEachConversation: '每次会话中，AI连续未能识别用户意图的最大轮次',
  withinEachConversation: '连续识别失败',
  aiNotRecognized: 'AI未识别用户意图',
  fallbackTipSettings: '兜底话术设置',
  recognitionFailed: '意图识别失败',
  greetings: '问候语',
  dclGreetings: '请输入问候语',
  enterOnlineConsultation: '进入在线咨询问候语',
  pleaseEnterAi2: '请输入AI客服昵称',
  pleaseEnterAi3: '请输入人工客服昵称',
  aiCustomerServiceIsAvailable: 'AI 客服在C端用户界面中显示的名称',
  aiCustomerService: 'AI 客服昵称',
  aiCustomerServiceHead: 'AI客服头像',
  aiRobot: 'AI客服设置',
  beforeEnteringTheConversation: '会话前分类设置',
  roleDescription: '角色描述',
  roleDescriptionPlaceholder: '描述AI客服的角色定位和回复风格',
  transferToManual: '是否允许转人工',
  transferToManualWay: '转人工方式',
  customerServiceOperationEquipment: '客服运营设置',
  aiServiceSettings: '客服配置',
  appliedToTheCEnd: '应用到C端',
  atTheLatestEffectiveDate: '最近发布时间: ',
  officiallyLaunched: '正式启用',
  unsyncedConfigTip: '存在未发布到 C 端的改动',
  modifiedBy: '修改人',
  unpublishedLeaveTip: '当前存在未发布到 C 端的改动，确定要离开吗？',
  editAndSave: '编辑并保存页面参数',
  customerServiceSettings: '客服设置生效提示：',
  saveFailedPlease: '保存失败，请稍后重试！',
  onlineConfigurationHasBeenCompleted: '线上配置已生效！',
  savedSuccessfully: '保存成功！可前往「H5配置」页面预览效果',
  firstUseAlready: '初次使用，已为您注入预设配置！',
  convertToManualProcessing: '转人工处理',
  alNotRecognized: 'Al未识别用户意图',
  preSessionSelection: '会话前选择分类',
  intelligentCustomerService: '智能客服',
  helloImGlad: '您好，很高兴为您服务，请问有什么可以帮您？',
  viewSwitch: '视图切换',
  pleaseEnterTheCategory: '请输入分类描述',
  pleaseEnterTheCategory2: '请输入分类名称',
  currentlyAvailableInMultipleLanguages: '暂无多语言配置，请选择语言添加配置',
  editMultipleLanguages: '编辑多语言配置',
  laHasBeenSetUp: '已设置{val1}种其他语言',
  canBeGrownAtTheTop: '可在顶部生效步骤中选择「下一步」进行操作',
  allUsersAreDividedInto:
    '所有用户分类信息更新后，须完成“更新到终端”步骤后，才能在C端H5页中统一生效',
  doNotShowAgain: '不再提示',
  allUpdatesAreNowAvailable: '全部更新即刻生效',
  continueUpdating: '继续更新',
  cEndEffectiveWithdrawal: 'C端生效提示',
  userClassificationSettings: '用户分类设置生效步骤：',
  updateToTerminal5: '更新到终端生效',
  updateAllUpdates: '将所有更新内容在C端H5中统一生效',
  nextStep: '下一步',
  updateAndSavePoints: '更新保存分类信息',
  afterTheApplicationTakesEffect: '应用生效后用户可选分类：',
  classificationHasBeenSet: '已设置分类在C端反馈提交H5中引用：',
  cEndAssistanceAnd:
    'C端帮助与反馈页中，用户提交反馈时选择的分类，可在【反馈设置→用户分类】模块中按不同来源设置',
  cannotBeOpenedAfterActivation: '(开启后不可关闭)',
  feedbackToIssue: '反馈转问题时，控制反馈的该字段能否被应用到对应问题中',
  whetherToApplyItTo: '是否应用到问题',
  customField: '自定义字段修改失败',
  cannotBeEmpty: '不能为空',
  theSortingValueMustBe: '排序值必须在0-9999之间',
  saveFailedPlease2: '保存失败，请检查输入',
  field2: '{val1}已存在，请修改',
  field3: '{val1}不能为空',
  refersToTheUserClicking: '指用户点击公告可跳转的链接',
  confirmDeletion: '确定要删除该来源及其下所有已选分类吗？',
  confirmDeletion2: '确定要删除该视图吗？',
  filterView: '筛选视图',
  defaultView: '默认视图',
  saveCurrentTemplate: '保存当前筛选条件作为快捷筛选',
  saveFilter: '根据当前筛选条件另存为新视图',
  pleaseEnterTemplateName: '请输入视图名称',
  updateCurrentView: '更新当前视图',
  templateName: '视图名称',
  templateNamePlaceholder: '请输入视图名称',
  canBeReferencedForUse: '可引用至用户分类的二级，且分类已设置用户可见',
  aSource: '个来源)',
  relatedUserSegmentation: '关联【用户分类】 (已选择',
  minimumAvailableVersion: '最低可用版本',
  maximumAvailableVersion: '最高可用版本',
  pleaseSelectInvalid: '请选择失效时间',
  whenSelectingFailure: '选择失效时间',
  neverExpire: '永不失效',
  afterExpirationItWill: '到期后会自动停用',
  theCurrentProductIs:
    '当前产品正在使用AiSee智能客服，FAQ须与分类关联，以确保AI客服回复的准确性',
  cEndUsersCan: 'C端用户可见',
  lostDuringSwitching: '（切换时将丢弃富文本中的格式或图片等）',
  plainText: '纯文本',
  richText: '富文本',
  totalTota6: '共 {val1} 条',
  setAsAHotspot: '设为热点',
  otherSettingsHaveBeenSetUp: '已设置其他语言数',
  whenTheValueIsNoF:
    '值为"否"时,FAQ仅用于AI客服答疑的语料；值为"是"时, 同时在C端帮助与反馈H5中显示，支持用户检索查看',
  cEndUsersAre: 'C端用户是否可见',
  userClassification: '个用户分类)',
  associated2: '(已关联',
  popular: '热门',
  multilingualSettings: '多语言设置',
  copyFailed2: '复制失败:',
  copyCommandLost: '复制命令失败',
  pleaseEnterTheAnswer: '请输入答案',
  editMultipleLanguages2: '编辑多语言成功',
  editMultipleLanguages3: '编辑多语言失败',
  userClicksOn:
    '用户点击 [在线咨询]\n                后不可选择分类，直接进入会话页，快捷答疑，不支持工单分流处理',
  relatedFeedbackScore: '关联【反馈分类】（业务管理类别）',
  userClicksOn2:
    '用户点击 [在线咨询]\n                后可选择分类，提供更加精准的AI答疑服务，也便于人工环节分流处理',
  relatedUserSegmentation2: '关联【用户分类】（用户可见类别）',
  theEffectAfterSwitching: '切换后的效果示例差异说明：',
  youConfirmThatF: '您确认将FAQ与反馈分类关联？',
  switchAssociated: '切换关联的分类后，已有历史关联分类将全部失效',
  faqSwitching: 'FAQ切换关联分类',
  alreadySwitchedForYou: '已为您切换至【{val1}】',
  faqAssociation: 'FAQ关联 【',
  usedToIdentify: '用于识别到对应场景，推送卡片收集用户问题信息',
  informationCollectionCard: '信息收集卡片配置',
  groupAll: '全部分组',
  filterGroups: '筛选分组',
  uploadFiles: '上传的文件内容不能为空，请检查文件后重试。',
  theRowI: '第{val1}行：失效日期必须晚于当前时间。',
  theRowI2:
    '第{val1}行：失效日期格式无法识别或无效。请使用 yyyy-mm-dd 或 yyyy-mm-dd hh:mm:ss 格式。',
  theRowI3: '第{val1}行：是否设置为热点字段值无效，应为"是"或"否"',
  theRowI4: '第{val1}行：C端用户可见字段值无效，应为"是"或"否"',
  theRowI5: '第{val1}行：是否设置为热点为必填项',
  theRowI6: '第{val1}行：排序为必填项',
  theRowI7: '第{val1}行：C端用户可见为必填项',
  theRowI8: '第{val1}行：FAQ答案为必填项',
  theRowI9: '第{val1}行：FAQ问题名称为必填项',
  stepUpdateLost: '步骤更新失败，请联系小助手',
  pleaseEnterGrouping: '请输入分组名',
  pleaseEnterTheMaximum: '请输入最大字符数',
  pleaseEnterAPrompt: '请输入提示文本',
  promptText: '提示文本',
  pleaseEnterOptions:
    '请输入选项，多个选项用英文逗号分隔（如：选项1,选项2,选项3）',
  optionValue: '选项值',
  fieldIdOnly: '字段ID只能包含字母、数字和下划线',
  pleaseEnterTheField2: '请输入字段ID',
  addField: '添加字段',
  addFieldMissing: '添加字段失败:',
  addFieldsAs: '添加字段成功',
  fieldIdAlready: '字段ID已存在，请使用其他ID',
  copyTitle: '复制标题',
  newCard: '新建卡片',
  pleaseEnterTheCard: '请输入卡片名称',
  cardName: '卡片名称',
  titleCopied: '已复制标题',
  currentData: '条数据，当前第',
  articleFaq: '条FAQ',
  pleaseEnterSearch: '搜索字段名称',
  onlyShowRequiredVisibleFields: '以下为自定义信息字段',
  manageFields: '管理字段',
  relatedFaq: '关联FAQ',
  contentPreview: '内容预览',
  faqTitle: 'FAQ标题',
  relatedFaq2: '关联FAQ失败',
  relatedFaq3: '关联FAQ失败:',
  relatedFaq4: '关联FAQ成功',
  pleaseSelectAtLeast: '请至少选择一个字段',
  getFaq: '获取FAQ列表失败',
  getFaq2: '获取FAQ列表失败:',
  submitting: '提交中...',
  newInformationCollection: '新增卡片',
  editInformationCollectionCard: '编辑卡片',
  scenarioDescription: '场景描述',
  pleaseEnterScenarioDescription: '请输入场景描述',
  scenarioExample:
    '告诉智能客服什么场景下应命中此卡片收集信息，如：用户咨询充值未到账相关问题',
  optionPrompt: '选项/提示',
  pleaseSelectTheLeftSide: '请选择左侧卡片，或新建卡片',
  saveSortingLost: '保存排序失败',
  sortSaved: '排序已保存',
  addFieldMissing2: '添加字段失败',
  deleted: '已删除',
  confirmDeletionOfThis: '确认删除该字段？',
  updateFailed: '更新失败！',
  updateSuccessful2: '更新成功！',
  thereIsCurrentlyNoAssociatedF2: '暂无关联FAQ',
  addAssociation: '新增关联',
  removalFailed: '移除失败',
  removedAssociation: '已移除关联',
  confirmToDeleteThis: '确定删除该卡片吗？删除后不可恢复',
  dateAndTime: '日期/时间',
  decimal: '小数',
  number2: '数字',
  theCardDoesNotExist: '卡片不存在',
  newField: '新字段',
  createCardLost: '创建卡片失败',
  disableClassification: '禁用分类',
  whenHoveringTheMouse: '鼠标悬停时点击',
  clearSelectedItems: '清空所选',
  cancelPaste: '撤销粘贴',
  paste: '粘贴',
  item: '项）',
  cut: '剪切（',
  batchOperation: '批量操作：',
  updatePriority: '更新优先级失败',
  illegalOperationsExist: '存在非法操作！{val1}',
  pasteFailed: '粘贴失败',
  pasteSuccessful: '粘贴成功',
  cannotClassify: '不能将分类粘贴到其子分类中',
  classifying: '】分类中？',
  pasteTo: '粘贴到【',
  andItsSubcategories: '及其子分类',
  itemClassification: '项】分类',
  willTheFollowingBeIncluded: '是否将以下【',
  confirmPaste: '确认粘贴',
  pleaseSelectFirst: '请先选择要粘贴到的目标分类',
  pleaseCopyThePartsFirst: '请先复制分类项',
  thePreviousOneHasBeenRevoked: '已撤销上一次粘贴操作',
  noRevocable: '没有可撤销的粘贴操作',
  selectedHasBeenCleared: '已清空所选项',
  cutSe: '已剪切{val1}个分类项',
  pleaseSelectFirst2: '请先选择要复制的分类项',
  getClassificationTree: '获取分类树失败',
  afterDisablingTheClassification: '分类禁用后，修改反馈分类操作时不可见',
  afterEnablingClassification: '启用分类后，修改反馈分类操作时可见',
  targetingAiCustomers:
    '针对AI客服或人工客服回复场景中相关的参数配置，如人工客服在线时间等',
  customerServiceSettings2: '客服设置',
  youCanAlsoTryIt: '您也可以尝试分析:',
  cloudRealMachineVerification: '云真机验证此问题',
  similarFeedbackS: '相似反馈 {val1}',
  similarInRecentDays: '近30天相似反馈',
  tpilo: 'tpilot智能场景ID',
  expandHid: '展开({val1})',
  proce: '{val1} 等{val2}人',
  forma: '{val1} 反馈',
  copyUserI: '复制用户Id成功',
  currentCollectionItems: '当前合集项目不支持回复',
  assignedHandler: '指定处理人',
  share2: '分享',
  replyToHistory: '回复历史',
  details: '详细信息',
  operationFailed: '操作失败',
  pleaseEnterAReply: '请输入回复的内容',
  moreSharing: '更多分享',
  sameModelCalibration: '同款机型校验',
  clickToEdit: '点击编辑',
  statusChange: '状态变更(',
  followUpOnTransferOrders: '转单跟进(',
  theCurrentStatusIsNot: '当前状态不支持编辑',
  associatedSession: '关联会话',
  viewRelatedFeedback: '查看关联反馈',
  viewRelatedSession: '查看关联会话',
  notDeleted: '未删除',
  sessionTime: '会话时间',
  deleteStatus: '删除状态',
  feedbackWithinThreeDays: '三天内反馈:',
  complete: '完成',
  feedbackClassificationHasBeenCompleted: '反馈分类已完成更新，支持手动校正',
  feedbackAutomaticScoring: '反馈自动分类后在此处查看，请等待3-5分钟后刷新列表',
  feedbackIntelligentScore: '反馈智能分类在此处查看，支持人工手动校正',
  openWidescreenMode2: '开启宽屏模式 (操作列将自动隐藏 )',
  pleaseChooseOneOr: '请选择一或多个处理人',
  pleaseSelectFeedback4: '请选择反馈处理状态',
  channel: '渠道',
  pleaseEnterTheChannel: '请输入渠道',
  excel: 'Excel数据为空',
  feedbackTypeIncorrect: '反馈类型错误,第{val1}行反馈类型必须是: {val2}',
  timeFormatError: '时间格式错误,第{val1}行反馈时间格式应为YYYY/MM/DD HH:mm:ss',
  theFeedbackContentIsNot: '反馈内容不能为空,第{val1}行反馈内容不能为空',
  whenCreatingAProblem: '问题创建时间',
  aiSee: 'AiSee反馈查询列表',
  aiSeeList: 'AiSee反馈查询',
  loading: '加载中...',
  queryTimeRange: '查询时间范围',
  allAuditStatements: '全部审核状态',
  reasonForApplication: '申请原因',
  thirdLevelProductI: '三级产品id',
  myApplication: '我的申请',
  joinedTheApplication: '已加入应用({val1})',
  pleaseEnterTheApplication: '请输入应用名称检索',
  thirdLevelApplicationName: '三级应用名称',
  firstLevelProductName: '一级产品名称',
  myApps: '我的应用',
  theAntiThatIAmConcernedAbout: '我关注的反馈',
  waitingForAnotherReply: '待再次回复反馈',
  feedbackHasBeenRepliedTo: '已回复反馈',
  myFollowUpQuestion: '我跟进的问题',
  operationsManagement: '运营管理',
  noFollowUpCurrentlyAvailable: '暂无跟进中的问题',
  aiConversation: 'AI会话',
  order: '工单',
  onlyViewMine: '仅查看我的订阅',
  allSubscribers: '全部订阅方式',
  dataSource: '数据来源',
  oncallTransfer: '是否转 Oncall',
  allOncallTransfer: '全部',
  notificationGroupName: '通知组名称',
  enterSubscriptionName: '输入订阅名称',
  enterNotificationGroup: '输入通知组名称',
  aiSee2:
    'AiSee提供了一些常用的用户反馈动态提醒，如实时反馈推送、反馈分类小结等，可以推送给个人或多人',
  youCanTakeTheNegative:
    '您可以将负责某一类反馈的业务成员设置为1个通知组，以便在不同规则设置通知时直接引用。',
  alarmRulesOften:
    '告警规则常用于高危风险或异常波动的风险处置，满足条件的反馈自动在【问题跟进】模块生成新问题并通知接收方，同时关联的反馈处理状态自动变更为”跟进中“。',
  notificationGroupManagement: '通知组管理',
  subscriptionPush: '订阅推送',
  notificationHistory: '通知历史',
  unableToDelete: '删除后无法恢复，确认删除吗',
  generateACopy: '生成副本',
  timePeriod: '时间段',
  subscriptionNotificationCalendar: '订阅通知历史',
  noFeedbackLetterAtTheMoment: '暂无反馈信息',
  copyI: '{val1}-副本',
  member: '成员',
  total: '{val1}个',
  classifyByFeedback: '按反馈分类设置',
  threeLevelClassification: '三级分类',
  subcategory: '二级分类',
  numbe: '{val1}级分类',
  three: '三',
  two: '二',
  one: '一',
  enterpriseWeChatGroupMachine: '企微群机器人',
  subscriber: '订阅人 :',
  scene: '场景',
  unsubscribed: '已取消订阅',
  subscribed: '已订阅',
  reviseErrorE: '修改错误: {val1}',
  activateSubscription: '开启订阅',
  editSubscription: '编辑订阅',
  subscribeToTot: '订阅: {val1} 个',
  newSubscription: '新建订阅',
  viewEnterpriseWeChat: '查看企微通知示例',
  detectingDataSources: '检测数据源',
  feedbackChannel: '反馈方式',
  store: '【{val1}】-创建的告警规则',
  understood: '知道了',
  clickToViewTheDisplay: '点击查看示例',
  clickSave: '点击保存',
  configureYourReport: '配置您的告警规则',
  subscriptionPushNotification: '订阅推送示例',
  enterpriseWeChatNotification: '企微通知示例',
  feedbackClassificationI: '反馈分类 ({val1})',
  onlyDisplayConfiguredOnes: '只显示已配置',
  enterCategoryName2: '输入分类名称/成员搜索',
  addMember: '添加成员',
  pleaseFillInTheRemarks: '请填写备注',
  notifyGroupMembers: '通知组成员',
  feedbackClassificationOnly:
    '反馈分类仅适用于统计维度配置为【智能分类】的规则。',
  youCanChoose:
    '您可以选择为不同的反馈分类标签，分别设置通知成员；注：新建成功后该选择不可修改。',
  didYouFollowTheFeedback: '是否按反馈分类设置',
  pleaseEnterNotification: '请输入通知组名称',
  field4: '{val1}不能仅包含空格',
  subscribeAfterCreation: '创建后订阅人将在企业微信中收到对应的消息提醒',
  pleaseChooseWhatYouWant: '请选择您要订阅的场景',
  clickToViewOrder: '点击查看订阅示例',
  youCanDoItHere: '您可以在此处配置订阅规则，并保存',
  youCanComeHere: '你可以在此处选择订阅场景',
  specificallyForSpecificScenes: '针对特定场景转人工，开启后可设置场景',
  inInformationCollectionCard: '信息收集卡片在FAQ管理中设置',
  sceneIndex: '场景 {val1}',
  sceneName: '场景名称',
  pleaseEnterSceneName: '请输入场景名称',
  sceneDescription: '场景描述',
  sceneDescriptionPlaceholder: '描述触发条件',
  sceneStrategy: '场景策略',
  sceneStrategyPlaceholder: 'AI 在该场景下的处理方式',
  addScene: '添加场景',
  customIntentMissingFields: '转人工特定场景设置中存在没有填写完整的场景',
  deleteSuccess: '删除成功',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  chooseDefaultSuccess: '切换到默认视图成功',
  chooseSuccess: '切换到{val1}视图成功',
  createAndSyncToAllProjects: '新建并同步到所有项目',
  saveAndSyncToAllProjects: '保存并同步到所有项目',
  syncToAllProjectsTip: '点击同步到一级项目下的所有有权限项目',
  syncResult: '同步结果',
  successSyncProjects: '成功同步的项目',
  failSyncProjects: '失败同步的项目',
  reason: '原因',
  noSyncResult: '暂无同步结果',
  addConversationToFaq: '将本次对话添加到FAQ',
  addNewFaq: '新增FAQ',
  gettingRecommendedFaq: '正在根据本次会话内容提炼FAQ...',
  defaultAddToGroupTip: '默认添加到「默认分组」的FAQ分组内，且C端用户不可见。',
  selectFaqGroup: '请选择FAQ分组',
  selectAll: '全选',
  syncToOtherProjects: '同步到其他项目',
  noOtherOptionalProjects: '暂无其他可选项目',
  pleaseSelectAtLeastOneCategory: '请选择至少一个分类',
  pleaseSelectAtLeastOneProject: '请选择至少一个项目',
  allProjects: '所有项目',
  syncSuccess: '同步成功',
  syncFailed: '同步失败',
  syncPartialFailed: '部分项目同步失败',
  triggerCondition: '触发条件',
  pleaseSelectAlarmRule: '请选择告警规则',
  pleaseSelectConditionField: '请选择条件字段',
  pluginExecMode: '插件执行方式',
  apiCallback: 'API 回调',
  agentFallbackName: '智能体{val1}',
  viewAgentTooltip: '查看智能体: {val1}',
  agentCallTag: '智能体调用 - {val1}',
  agentUnbound: '智能体调用，未绑定智能体',
  creatorPerson: '创建人',
  agentModeNotSupportDetect: '智能体模式暂时不支持检测',
  pleaseEnterApiAddress: '请输入接口地址',
  pleaseSelectAgent: '请选择智能体',
  pleaseConfigFilter: '请配置筛选条件',
  saveFailedRetry: '保存失败，请重试',
  editTriggerSettings: '编辑触发设置',
  newTrigger: '新建触发',
  saveButton: '保存',
  cancelButton: '取消',
  triggerNodeTitle: '触发节点',
  selectAlarmRuleLabel: '选择告警规则',
  allAlarmRules: '全部告警规则',
  selectedAlarmRuleCount: '已选 {val1} 个告警规则',
  pluginNameLabel: '插件名称',
  manualTrigger: '手动触发',
  agentNotSupportManual: '插件执行方式为智能体时暂不支持手动触发',
  pleaseSelectSmartCategory: '请选择智能分类',
  pleaseSelectClassification: '请选择分类',
  filterConditionTitle: '筛选条件',
  newFeedbackTriggerDesc: '新反馈产生时触发',
  noAvailableFields: '暂无可用字段',
  pleaseSelectTriggerNode: '请先选择触发节点',
  agentLabel: '智能体',
  execCurrentAgent: '执行当前智能体（{val1}）',
  agentSelectionLabel: '智能体选择',
  apiAddressLabel: '接口地址',
  apiUrlPlaceholder: '请输入接口 URL',
  addRequestHeader: '添加请求头',
  pleaseEnterKeyIndex: '请输入 Key{val1}',
  pleaseEnterValueIndex: '请输入 Value{val1}',
  newFeedbackGenerated: '新反馈产生',
  hitClassification: '命中分类',
  statusChangeNode: '状态变化',
  alarmRuleNode: '告警规则',
  scheduleTriggerNode: '定时触发',
  triggerFrequencyLabel: '触发频率',
  triggerWindowLabel: '触发时段',
  pleaseSelectTriggerFrequency: '请选择触发频率',
  unsupportedScheduleFrequency: '触发频率不在支持范围内',
  pleaseSelectTriggerWindow: '请选择触发时段',
  scheduleWindowMaxDays: '触发时段不能超过 3 天',
  triggerPastWindowFeedback: '触发过去{val1}{val2}的反馈',
  scheduleConditionPrefix: '条件',
  scheduleSummaryEveryPrefix: '每',
  scheduleSummaryRecentPrefix: '最近',
  logicalAnd: '且',
  logicalOr: '或',
  manualTriggerNode: '手动触发',
  newFeedbackReport: '新反馈上报',
  customFieldBinding: '自定义字段绑定',
  triggerAlarmText: '触发告警',
  triggerAlarmWithName: '触发告警 {val1}',
  allClassifications: '全部分类',
  pluginDetection: '插件检测',
  inputSectionTitle: '输入',
  executionResultTitle: '执行结果',
  executeDetection: '执行检测',
  emptyResultHint: '填写输入参数后，点击「执行检测」，结果将显示在此处',
  feedbackIdPlaceholder: '请输入反馈 ID，如：1a418e8bb82126aa',
  pleaseSelect: '请选择',
  conditionIs: '为',
  conditionBecomesTo: '变为',
  delayTimeSeconds: '延迟时间(秒)',
  delayTimeHint: '选填，触发后延迟执行的时间',
  queryFieldFailed: '字段查询失败',
  feedbackOptionalField: '反馈选填字段',
  feedbackOptionalFieldTip:
    '反馈填写页面，用户选择此分类后的额外的选填自定义字段',
  effectiveTimeMustBeBeforeExpireTime: '生效时间必须早于失效时间',
  comingFrom: '场景',
  createFaqSyncKbBanner: '提示：新建的 FAQ 将自动同步到知识库',
  editFaqSyncKbBanner: '提示：当前 FAQ 已关联知识库，修改后将同步到知识库',
  faqSyncedToKb: '已同步到知识库',
};
